import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { OrganisationSettingsPage } from "~/pages/Settings/Organisations/organisation/settings/OrganisationSettingsPage";

export const Route = createFileRoute(
  "/_app/settings/organisations/$organisationId/settings/",
)({
  head: () => ({
    meta: [{ title: i18n.t("general:documentTitle.organisationSettings") }],
  }),
  component: OrganisationSettingsPage,
});
